import { render, staticRenderFns } from "./jurisdictionSet.vue?vue&type=template&id=e8c3b540&"
import script from "./jurisdictionSet.vue?vue&type=script&lang=js&"
export * from "./jurisdictionSet.vue?vue&type=script&lang=js&"
import style0 from "./jurisdictionSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports